import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  portInfor: Object,
},
  setup(__props) {

const props = __props

const { appContext } = getCurrentInstance();
const vm = appContext.config.globalProperties;
console.log("ctx", vm);
const router = useRouter();



const state = reactive({
  pwdSuffixImg: require("@/assets/images/alexa/ic_16_arrow@3x.png"),
});

const { pwdSuffixImg } = toRefs(state);
const jumpPort = () => {
  router.push(
    `/${vm.$commonFunc.getUrlChannelAppID()}/sel-port${
      vm.$commonFunc.linkUrlParams()
    }`
  );
};
// export default {
//   data() {
//     return {
//       pwdSuffixImg: require("@/assets/images/alexa/ic_16_arrow@3x.png"),
//     };
//   },
//   props: {
//     portInfor: {
//       // type: Object,
//       // default: () => {},
//     },
//   },
//   methods: {
//     jumpPort() {
//       this.$router.push(`/${this.$commonFunc.getUrlChannelAppID()}/sel-port`);
//     },
//   },
// };

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "port",
    onClick: jumpPort
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.portInfor.area), 1),
    _createVNode(_component_el_image, {
      class: "el-img",
      src: _unref(pwdSuffixImg),
      fit: "contain"
    }, null, 8, ["src"])
  ]))
}
}

})